module.exports = __webpack_public_path__ + "static/12-d02a79936cd36e787ffd82467446660c.jpg";